import { render, staticRenderFns } from "./LabelCombo.vue?vue&type=template&id=70cdf281&"
import script from "./LabelCombo.vue?vue&type=script&lang=ts&"
export * from "./LabelCombo.vue?vue&type=script&lang=ts&"
import style0 from "./LabelCombo.vue?vue&type=style&index=0&id=70cdf281&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports